export const API_BASE_URL = 'https://grociesmart.visssible.com/backend/';
